import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    meetParams: {
      ageGroup:'',
      meetName:'',
      teamName:'',
      meetDate:'',
      individualLane:'',
      shuttleLane:''
    },
    newRoster:{}
  },
  mutations: {
    setMeetParams: (state, newParams) => {
      state.meetParams = newParams;
    },
    setNewRoster: (state, newRoster) => {
      state.newRoster = newRoster;
    }

  },
  actions: {

  }
})
